module.exports = __webpack_public_path__ + "static/media/icon-hesabim.acfd9054.svg";